
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";

/**
 * bool Option -> bool, with None -> false
 */
export function jsToBool(b) {
    return defaultArg(b, false);
}

